import React, { useState } from "react"
import Layout from "components/layout"
import Seo from "../../../components/seo";
import PageLead from "../../../components/pageLead";
import EntryForm from "../../../components/entry/form";
import EntryConfirm from "../../../components/entry/confirm";
import EntryComplete from "../../../components/entry/complete";
import {graphql} from "gatsby";


const EntryPage = (data) => {
    const [entryState, setEntryState] = useState({
        step: 'form',
    });
    const [formData, setFormData] = useState({
        job_position: '',
        name: '',
        email: '',
        tel: '',
        public_relation: '',
        comment: ''
    })

    const handleOnNextPage = data => {
        setFormData({
            ...formData,
            job_position: data.job_position,
            name: data.name,
            email: data.email,
            tel: data.tel ?? "",
            public_relation: data.public_relation ?? "",
            comment: data.comment ?? ""
        });

        let nextStep = 'form';
        if (entryState.step === 'form'){
            nextStep = 'confirm';
        }else if (entryState.step === 'confirm'){
            nextStep = 'complete';
        }

        setEntryState({
            ...entryState,
            step: nextStep,
        })
    }
    const handleOnBackPage = () => {
        let prevStep = 'confirm';
        if (entryState.step === 'confirm'){
            prevStep = 'form';
        }
        setEntryState({
            ...entryState,
            step: prevStep,
        })
    }

    return (
        <Layout>
            <div className="entry-page">
                <PageLead sub="CAREERS"
                          title="採用情報"
                />
                <div className="contents">
                    <EntryForm
                        jobPositions={data.data.allStrapiJobPosition}
                        entryState={entryState}
                        handleOnNextPage={handleOnNextPage}
                    />
                    <EntryConfirm
                        entryState={entryState}
                        handleOnNextPage={handleOnNextPage}
                        handleOnBackPage={handleOnBackPage}
                        formData={formData}
                    />
                    <EntryComplete
                        entryState={entryState}
                    />
                </div>
            </div>
        </Layout>
    )
}

export const Head = () => (
    <Seo
        title="エントリー"
        description="株式会社OKULABの採用情報｜「幸せな洗濯をすべての人に」ともにミッションを目指す仲間を募集しています。募集中の職種、エントリーはこちら。"
    />
)
export default EntryPage

export const query = graphql`
  query {
    allStrapiJobPosition(
      sort: { fields: [publishedAt], order: DESC }
    ) {
      edges {
          node {
            division
            job_position
            strapi_id
          }
        }
    }
  }
`
